import { facet1Template } from './facet-1'
import { facet2Template } from './facet-2'
import { facet3Template } from './facet-3'
import { facet4Template } from './facet-4'
import { facet5Template } from './facet-5'
import { facet6Template } from './facet-6'
import { facet7Template } from './facet-7'
import { facet8Template } from './facet-8'
import { facet9Template } from './facet-9'
import { facet10Template } from './facet-10'
import {TemplateResult} from "lit";

const facets: {[key: number]: (isDefault:boolean) => TemplateResult<1>} = {
    1: facet1Template,
    2: facet2Template,
    3: facet3Template,
    4: facet4Template,
    5: facet5Template,
    6: facet6Template,
    7: facet7Template,
    8: facet8Template,
    9: facet9Template,
    10: facet10Template,
};

export const allFacets = {
    getFacet(number: number, isDefault: boolean = true) {
        return facets[number](isDefault);
    }
};